import { useTheme } from '../../index'
import { getPanelWidth } from '../../utils/helpers'

export const useConfigPanelStyles = () => {
  const theme = useTheme()

  const getNotificationPanelStyles = ({
    lgUp,
    smUp,
    notificationCenterPosition,
    notificationCenterOffset
  }) => ({
    borderRadius: '10px',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    width: getPanelWidth(lgUp, smUp),
    backgroundColor: theme.palette.background.paper,
    position:
      notificationCenterPosition === 'left' ||
      notificationCenterPosition === 'right'
        ? 'fixed'
        : 'relative',
    ...(notificationCenterPosition === 'left' ||
    notificationCenterPosition === 'right'
      ? { top: 0 }
      : {}),
    ...(notificationCenterPosition === 'left'
      ? { left: notificationCenterOffset || '2rem' }
      : {}),
    ...(notificationCenterPosition === 'right'
      ? { right: notificationCenterOffset || '2rem' }
      : {})
  })

  const bodyContainerStyles = {
    position: 'relative'
  }

  const getBodyWrapperStyles = (openConfigUnsaved) => ({
    backgroundColor: theme.palette.background.paper,
    opacity: openConfigUnsaved ? 0.4 : 1,
    filter: openConfigUnsaved ? 'grayscale(50%)' : 'none',
    transition: 'opacity 0.3s ease, filter 0.3s ease'
  })

  const getOverlayStyles = () => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(0, 0, 0, 0.5)'
        : 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
    zIndex: 1,
    pointerEvents: 'none'
  })

  const keyframesStyles = `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `

  return {
    getNotificationPanelStyles,
    bodyContainerStyles,
    getBodyWrapperStyles,
    getOverlayStyles,
    keyframesStyles
  }
}
